export default __webpack_public_path__ + "static/media/biofit-builder-series-MTCL.fbdae503.png";